import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { enableSFTPNetworkElement } from '@api/networkElements';

import { INetworkElementsSFTPPathsDTO } from '@interfaces/networkElements/dto/networkElements';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes } from '@enums/common';

import { NETWORK_ELEMENTS_ENABLE_SFTP } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementsEnableSFTPReturned {
	handleEnableSFTP: (dto: INetworkElementsSFTPPathsDTO) => void;
	isLoadingEnableSFTP: boolean;
}

const useMutateNetworkElementsEnableSFTP = (
	handleCloseModal: () => void,
): IUseMutateNetworkElementsEnableSFTPReturned => {
	const invalidateNetworkElements = useInvalidateNetworkElements();
	const dispatch = useAppDispatch();

	const {
		mutateAsync,
		isLoading,
	} = useMutation<INetworkElementsSFTPPathsDTO>({
		mutationKey: [NETWORK_ELEMENTS_ENABLE_SFTP],
		mutationFn: enableSFTPNetworkElement,
		onSuccess: (data: INetworkElement) => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.enableNetworkElementsSFTP(data.name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
	});

	return {
		handleEnableSFTP: mutateAsync,
		isLoadingEnableSFTP: isLoading,
	};
};

export default useMutateNetworkElementsEnableSFTP;
